import { NgModule } from '@angular/core';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { MonthDatePickerComponent } from './month-date-picker.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule, NgbDropdownModule, FormsModule],
  declarations: [MonthDatePickerComponent],
  exports: [MonthDatePickerComponent],
})
export class DatePickerModule {}
